// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__rk-ay","filled":"Button_filled__CFvy-","outlined":"Button_outlined__u6jAU"};